/*
 * cz-bundle-swatch-sync.js
 * Fix voor de "Create your outfit" (products-bundle-selection) sectie i.c.m. Rubik Combined Listings.
 *
 * Probleem: een Rubik-swatch wisselt alleen foto/titel van de productkaart. Het maatmenu,
 * de product-id en de prijs blijven van het oorspronkelijke product, dus er komt een
 * andere kleur in de cart en uitverkochte maten zijn kiesbaar.
 *
 * Oplossing: bij elke swatch-wissel het gekozen product ophalen (/products/<handle>.js)
 * en het formulier van die kaart (select, product-id, url) daarop bijwerken.
 */
(() => {
  const SECTION = 'products-bundle-selection';
  const cache = new Map();

  const getProduct = (url) => {
    const handleUrl = url.split('?')[0].replace(/\/$/, '');
    if (!cache.has(handleUrl)) {
      cache.set(handleUrl, fetch(`${handleUrl}.js`).then((r) => {
        if (!r.ok) throw new Error(`Product fetch failed: ${handleUrl}`);
        return r.json();
      }));
    }
    return cache.get(handleUrl);
  };

  const soldOutLabel = () => (window.FoxTheme?.variantStrings?.soldOut) || 'Sold out';

  const activeSwatchUrl = (wrapper) => {
    const sr = wrapper.querySelector('rubik-combined-listings')?.shadowRoot;
    const a = sr?.querySelector('a.rcl__swatch--active, a.rcl__swatch[aria-current="true"]');
    return a ? new URL(a.getAttribute('href'), location.origin).pathname : null;
  };

  async function syncCard(wrapper, targetUrl) {
    const form = wrapper.querySelector('form[is="product-bundle-selection"]');
    if (!form || !targetUrl) return;
    const current = form.dataset.productUrl?.split('?')[0];
    if (current === targetUrl) return;

    const btn = form.querySelector('button[type="submit"]');
    btn?.setAttribute('aria-disabled', 'true');
    form.dataset.czSyncing = 'true';

    try {
      const product = await getProduct(targetUrl);
      // Rubik kan intussen alweer een andere kleur gekozen hebben
      if (activeSwatchUrl(wrapper) && activeSwatchUrl(wrapper) !== targetUrl) return;

      const select = form.querySelector('select[name="id"]');
      const prevTitle = select.selectedOptions[0]?.textContent.replace(/-.*$/s, '').trim();

      select.innerHTML = '';
      let selected = null;
      product.variants.forEach((v) => {
        const opt = document.createElement('option');
        opt.value = v.id;
        opt.dataset.price = v.price;
        opt.textContent = v.available ? v.title : `${v.title} - ${soldOutLabel()}`;
        opt.disabled = !v.available;
        select.appendChild(opt);
        if (!selected && v.available && v.title === prevTitle) selected = opt;
      });
      // zelfde maat houden als die beschikbaar is, anders eerste beschikbare maat
      selected = selected || [...select.options].find((o) => !o.disabled);
      if (selected) selected.selected = true;

      const pid = String(product.id);
      form.dataset.productId = pid;
      form.dataset.productUrl = targetUrl;
      const pidInput = form.querySelector('input[name="product-id"]');
      if (pidInput) pidInput.value = pid;
      wrapper.dataset.productId = pid;
      const card = wrapper.closest('.product-card');
      if (card) card.dataset.productId = pid;

      // als alles uitverkocht is: knop uit
      if (selected) btn?.removeAttribute('aria-disabled');
    } catch (e) {
      console.error('[cz-bundle-swatch-sync]', e);
      btn?.removeAttribute('aria-disabled');
    } finally {
      delete form.dataset.czSyncing;
    }
  }

  function watchCard(wrapper) {
    if (wrapper.dataset.czSwatchSync) return;
    const rcl = wrapper.querySelector('rubik-combined-listings');
    if (!rcl) return;

    const check = () => {
      const url = activeSwatchUrl(wrapper);
      if (url) syncCard(wrapper, url);
    };

    const attach = () => {
      if (!rcl.shadowRoot) return false;
      new MutationObserver(check).observe(rcl.shadowRoot, {
        subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-current'],
      });
      check();
      return true;
    };

    wrapper.dataset.czSwatchSync = 'true';
    if (!attach()) {
      // Rubik rendert asynchroon; wachten tot de shadow root er is
      let tries = 0;
      const t = setInterval(() => { if (attach() || ++tries > 40) clearInterval(t); }, 250);
    }
  }

  function init(root = document) {
    root.querySelectorAll(`${SECTION} .product-card__wrapper`).forEach(watchCard);
  }

  // Vangnet: niet toevoegen aan de bundle terwijl een kaart nog aan het syncen is
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form?.matches?.('form[is="product-bundle-selection"]') && form.dataset.czSyncing) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  // kaarten die later (lazy) in de sectie komen
  new MutationObserver(() => init()).observe(document.documentElement, { childList: true, subtree: true });
})();